import { PropType } from 'vue'
import { KnowledgeBaseLlmResponse } from '@/libs/features/llm/types'

import { AskSopInputForm } from '@/tokens/llm/AskSOPModal/AskSOPModalInputs/types'

export const ASK_SOP_RESPONSE_PROPS = {
  inputs: {
    type: Object as PropType<AskSopInputForm | undefined>,
    default: undefined,
  },
  response: {
    type: Object as PropType<KnowledgeBaseLlmResponse | undefined>,
    default: undefined,
  },
  loading: {
    type: Boolean,
    required: true,
  },
  error: {
    type: Object as PropType<Error | undefined>,
    default: undefined,
  },
  showDevTools: {
    type: Boolean,
    default: false,
  },
}
